import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import { oneKlicks } from "../../SDK/oneclick";
import { debugLog } from "../../utils/debug";
import { toast } from 'react-toastify';
import { getuserdata } from "../../services/apiService";
import BreakTimeModal from "./Components/BrackTime";
import {
    Table,
    Tag,
    Button,
    Tooltip,
    Empty,
    Collapse,
    Space,
    Form,
    Select,
    InputNumber,
    Card,
    Typography,
    Badge,
    Popconfirm,
    Skeleton,
    Divider,
    Alert
} from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    EyeOutlined,
    ClockCircleOutlined,
    EnvironmentOutlined,
    CheckCircleFilled,
    DollarCircleOutlined,
    CalendarOutlined,
    SearchOutlined,
    HomeOutlined,
    InfoCircleOutlined
} from '@ant-design/icons';
import ImageShow from "../../Uitiles/ImageShow";
import DayTimeSlots from "./Components/DayTimeSlots";

const { Panel } = Collapse;
const { Title, Text } = Typography;
const { Option } = Select;

const AppointmentSettings = ({ userId, doctorData, onActivityLog }) => {
    const [form] = Form.useForm();
    const [userdata, setUserdata] = useState({});
    const [hospitalList, setHospitalList] = useState([]);
    const [appointmentSettings, setAppointmentSettings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [selectedBreakView, setSelectedBreakView] = useState(null);
    const [showBreakTimeModal, setShowBreakTimeModal] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState(null);

    const sanitizeHospitalName = (name) => {
        if (!name) return '';
        return name
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&nbsp;/g, ' ')
            .trim();
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            if (userId && doctorData) {
                setUserdata(doctorData);
            } else {
                const data = await getuserdata('full');
                if (data) setUserdata(data);
            }
            await getAppointmentSettings();
            await getHospitalList('');
            setLoading(false);
        };
        init();
    }, [userId, doctorData]);

    const getAppointmentSettings = async () => {
        try {
            const user_id = userId || await getuserdata('id');
            const margedata = [
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "hospital_id",
                    target_label: "hospital_name"
                },
                {
                    target_table: "doctor_break_time",
                    target_column: "appointment_setting_id",
                    target_value: "id",
                    target_label: "doctor_break_time"
                }
            ];
            const response = await oneKlicks.read("", "appointment_settings", { doctor_id: user_id }, "id DESC", "", "", margedata);
            if (response.success) {
                setAppointmentSettings(response.data);
            }
        } catch (err) {
            console.error('Error fetching appointment settings:', err);
        }
    }

    const getHospitalList = async (search = '') => {
        try {
            const searchObj = search ? { display_name: search } : {};
            const response = await oneKlicks.read("", "users", { user_type: "hospitals" }, "id DESC", searchObj, "20", {});
            if (response.success) {
                setHospitalList(response.data);
            }
        } catch (err) {
            console.error('Error fetching hospital list:', err);
        }
    }

    const handleFormSubmit = async (values) => {
        setIsSubmitting(true);
        try {
            const user_id = userId || await getuserdata('id');
            const data = {
                hospital_id: values.hospital_id,
                doctor_id: user_id,
                selected_days: JSON.stringify(values.selected_days),
                day_time_slots: JSON.stringify(values.day_time_slots),
                intervals: values.intervals || '',
                durations: values.durations,
                content: values.content || '',
                spaces: values.spaces,
                week_days: JSON.stringify(values.selected_days),
                consultant_fee: values.consultant_fee,
                book_before: values.book_before || '',
                status: "pending"
            };

            const response = isEditing
                ? await oneKlicks.update("", "appointment_settings", data, { id: editingId })
                : await oneKlicks.create("", "appointment_settings", data, {});

            if (response.success) {
                toast.success(isEditing ? 'Settings updated' : 'Location added successfully');
                resetForm();
                getAppointmentSettings();
                if (onActivityLog) {
                    onActivityLog(
                        "appointment_settings_update",
                        `${isEditing ? 'updated' : 'added new'} hospital appointment schedule settings (Hospital ID: ${values.hospital_id}, Fee: ₹${values.consultant_fee})`
                    );
                }
            }
        } catch (error) {
            toast.error("An error occurred during save");
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        form.resetFields();
        setIsEditing(false);
        setEditingId(null);
    };

    const handleEditClick = (item) => {
        const hospital = item.hospital_name?.[0];
        if (!hospital) return;

        setIsEditing(true);
        setEditingId(item.id);

        let selectedDays = [];
        let dayTimeSlots = {};
        try {
            selectedDays = JSON.parse(item.selected_days);
            dayTimeSlots = typeof item.day_time_slots === 'string' ? JSON.parse(item.day_time_slots) : item.day_time_slots;
        } catch (e) { }

        form.setFieldsValue({
            hospital_id: hospital.id,
            selected_days: selectedDays,
            day_time_slots: dayTimeSlots,
            intervals: item.intervals,
            durations: item.durations,
            consultant_fee: item.consultant_fee,
            book_before: item.book_before,
            content: item.content,
            spaces: item.spaces
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (id) => {
        const res = await oneKlicks.delete("", "appointment_settings", { id });
        if (res.success) {
            toast.success('Location removed');
            getAppointmentSettings();
            if (onActivityLog) {
                onActivityLog("appointment_settings_delete", `deleted hospital appointment schedule settings (Schedule ID: ${id})`);
            }
        }
    };

    const formatTime = (time) => {
        if (!time || time === 'closed') return 'Closed';
        if (time === '0000' || time === '2400') return '24 Hours';
        const hours = parseInt(time.substring(0, 2));
        const minutes = time.substring(2);
        const period = hours >= 12 ? 'PM' : 'AM';
        return `${hours % 12 || 12}:${minutes} ${period}`;
    };

    return (
        <>
            <style>{`
                .appointment-settings-container {
                    padding: 24px;
                    background: #f8fafc;
                    min-height: 100vh;
                }
                .premium-card {
                    background: #fff;
                    border-radius: 16px;
                    border: 1px solid #edf2f7;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    margin-bottom: 24px;
                    overflow: hidden;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                }
                .premium-card:hover {
                    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
                    transform: translateY(-4px);
                }
                .card-header-premium {
                    padding: 24px;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    border-bottom: 1px solid #f1f5f9;
                }
                .hospital-info-box {
                    display: flex;
                    gap: 16px;
                }
                .hospital-img-wrapper {
                    width: 56px;
                    height: 56px;
                    border-radius: 14px;
                    background: #f1f5f9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #e2e8f0;
                }
                .hospital-text-info h4 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 700;
                    color: #1e293b;
                }
                .hospital-text-info p {
                    margin: 4px 0 0;
                    font-size: 14px;
                    color: #64748b;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .stat-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 12px;
                    padding: 20px 24px;
                    background: #fcfdfe;
                }
                .stat-box {
                    padding: 12px;
                    background: #fff;
                    border: 1px solid #f1f5f9;
                    border-radius: 12px;
                    text-align: center;
                }
                .stat-box-label {
                    font-size: 11px;
                    text-transform: uppercase;
                    color: #94a3b8;
                    letter-spacing: 0.05em;
                    font-weight: 600;
                }
                .stat-box-value {
                    font-size: 15px;
                    font-weight: 700;
                    color: #334155;
                    margin-top: 4px;
                    display: block;
                }
                .form-card-premium {
                    background: #fff;
                    border-radius: 24px;
                    padding: 32px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.08);
                    border: 1px solid #e2e8f0;
                    position: sticky;
                    top: 24px;
                }
                .schedule-collapse-premium .ant-collapse-header {
                    background: #f8fafc;
                    border-radius: 12px !important;
                    margin: 0 24px 20px;
                    padding: 12px 16px !important;
                }
                .schedule-table-compact {
                    width: 100%;
                }
                .schedule-table-compact td {
                    padding: 10px 0;
                    font-size: 13px;
                    border-bottom: 1px solid #f1f5f9;
                }
                .day-name-cell {
                    font-weight: 600;
                    color: #475569;
                    width: 100px;
                }
                .time-slots-cell {
                    text-align: right;
                    color: #1e293b;
                }
                .action-footer {
                    padding: 16px 24px 24px;
                    display: flex;
                    gap: 12px;
                }
                .ant-select-selection-search-input {
                    height: 48px !important;
                }
                .ant-select-selector {
                    border-radius: 12px !important;
                    height: 48px !important;
                    display: flex;
                    align-items: center;
                }
            `}</style>

            <div className="appointment-settings-container">
                {!userId && userdata.activation_key == null && <EmailVerify />}

                <div className="row g-4">
                    {/* Left: Settings List */}
                    <div className="col-xl-7 col-lg-6">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <Title level={2} style={{ margin: 0, fontWeight: 800 }}>Manage Schedules</Title>
                                <Text type="secondary">View and edit your availability across hospitals</Text>
                            </div>
                            <Badge count={appointmentSettings.length} overflowCount={99} color="#3182ce" />
                        </div>

                        {loading ? (
                            <Skeleton active avatar paragraph={{ rows: 4 }} className="premium-card p-4" />
                        ) : appointmentSettings.length > 0 ? (
                            appointmentSettings.map((item) => {
                                const hospital = item.hospital_name?.[0] || {};
                                let dayTimeSlots = {};
                                try {
                                    dayTimeSlots = typeof item.day_time_slots === 'string' ? JSON.parse(item.day_time_slots) : item.day_time_slots;
                                } catch (e) { }

                                return (
                                    <div key={item.id} className="premium-card">
                                        <div className="card-header-premium">
                                            <div className="hospital-info-box">
                                                <div className="hospital-img-wrapper">
                                                    <ImageShow url={hospital.profile_photo_url} height={44} width={44} style={{ borderRadius: '10px' }} />
                                                </div>
                                                <div className="hospital-text-info">
                                                    <h4>
                                                        {sanitizeHospitalName(hospital.display_name)}
                                                        {hospital.verified == 1 && <CheckCircleFilled style={{ color: '#38a169', marginLeft: 8 }} />}
                                                    </h4>
                                                    <p><EnvironmentOutlined /> {hospital.address || 'Standard Location'}</p>
                                                </div>
                                            </div>
                                            <Tag color={item.status === 'publish' ? 'success' : 'warning'} style={{ borderRadius: '6px', fontWeight: 600 }}>
                                                {item.status?.toUpperCase() || 'PENDING'}
                                            </Tag>
                                        </div>

                                        <div className="stat-grid">
                                            <div className="stat-box">
                                                <span className="stat-box-label">Consultation</span>
                                                <span className="stat-box-value" style={{ color: '#0ea5e9' }}>₹{item.consultant_fee}</span>
                                            </div>
                                            <div className="stat-box">
                                                <span className="stat-box-label">Duration</span>
                                                <span className="stat-box-value"><ClockCircleOutlined /> {item.durations}m</span>
                                            </div>
                                            <div className="stat-box">
                                                <span className="stat-box-label">Daily Slots</span>
                                                <span className="stat-box-value">{item.spaces} Slots</span>
                                            </div>
                                        </div>

                                        <Collapse ghost expandIconPosition="end" className="schedule-collapse-premium">
                                            <Panel
                                                header={<Text strong style={{ fontSize: '13px', color: '#64748b' }}><CalendarOutlined /> Weekly Schedule Details</Text>}
                                                key="1"
                                            >
                                                <table className="schedule-table-compact">
                                                    <tbody>
                                                        {['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map(day => {
                                                            const slots = dayTimeSlots[day] || [];
                                                            return (
                                                                <tr key={day}>
                                                                    <td className="day-name-cell">{day.toUpperCase()}</td>
                                                                    <td className="time-slots-cell">
                                                                        {slots.length > 0 ? (
                                                                            slots.map((s, idx) => (
                                                                                <div key={idx} style={{ color: s.start_time === 'closed' ? '#ef4444' : '#0f172a' }}>
                                                                                    {formatTime(s.start_time)} - {formatTime(s.end_time)}
                                                                                </div>
                                                                            ))
                                                                        ) : <Text type="danger">Closed</Text>}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </Panel>
                                        </Collapse>

                                        {item.doctor_break_time?.length > 0 && (
                                            <div className="px-4 mb-3">
                                                <Alert
                                                    message={`${item.doctor_break_time.length} Break times configured`}
                                                    type="warning"
                                                    showIcon
                                                    action={
                                                        <Button size="small" type="ghost" onClick={() => setSelectedBreakView(selectedBreakView === item.id ? null : item.id)}>
                                                            {selectedBreakView === item.id ? 'Hide' : 'View'}
                                                        </Button>
                                                    }
                                                />
                                            </div>
                                        )}

                                        <div className="action-footer">
                                            <Button
                                                type="primary"
                                                icon={<EditOutlined />}
                                                onClick={() => handleEditClick(item)}
                                                style={{ flex: 1, height: 44, borderRadius: '12px', fontWeight: 600 }}
                                            >
                                                Edit Settings
                                            </Button>
                                            <Tooltip title="Add Break">
                                                <Button
                                                    icon={<PlusOutlined />}
                                                    onClick={() => {
                                                        setSelectedAppointment(item);
                                                        setShowBreakTimeModal(true);
                                                    }}
                                                    style={{ width: 44, height: 44, borderRadius: '12px', color: '#059669', borderColor: '#10b981' }}
                                                />
                                            </Tooltip>
                                            <Popconfirm
                                                title="Delete this schedule?"
                                                description="Are you sure you want to remove this location's settings?"
                                                onConfirm={() => handleDelete(item.id)}
                                                okText="Yes, Delete"
                                                cancelText="No"
                                                okButtonProps={{ danger: true }}
                                            >
                                                <Button
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    style={{ width: 44, height: 44, borderRadius: '12px' }}
                                                />
                                            </Popconfirm>
                                        </div>

                                        {selectedBreakView === item.id && (
                                            <div className="p-4 border-top animate__animated animate__fadeIn">
                                                <Table
                                                    size="small"
                                                    pagination={false}
                                                    dataSource={item.doctor_break_time}
                                                    rowKey="id"
                                                    columns={[
                                                        { title: 'Date', dataIndex: 'select_date' },
                                                        { title: 'Type', dataIndex: 'break_type', render: t => <Tag>{t.replace('_', ' ')}</Tag> },
                                                        { title: 'Time', render: (_, r) => r.break_type === 'full_day' ? 'Full Day' : `${r.from_time} - ${r.to_time}` },
                                                    ]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description="No schedules found. Start by adding a hospital location."
                                className="premium-card p-5"
                            />
                        )}
                    </div>

                    {/* Right: Form */}
                    <div className="col-xl-5 col-lg-6">
                        <div className="form-card-premium">
                            <div className="mb-4">
                                <Title level={3} style={{ margin: 0, fontWeight: 800 }}>
                                    {isEditing ? 'Update Schedule' : 'New Location'}
                                </Title>
                                <Text type="secondary">Define where and when you're available</Text>
                            </div>

                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={handleFormSubmit}
                                initialValues={{
                                    durations: 15,
                                    intervals: 15,
                                    spaces: 1,
                                    selected_days: []
                                }}
                            >
                                <Form.Item
                                    name="hospital_id"
                                    label={<Text strong>Select Hospital</Text>}
                                    rules={[{ required: true, message: 'Please select a hospital' }]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Search by hospital name..."
                                        onSearch={getHospitalList}
                                        filterOption={false}
                                        suffixIcon={<SearchOutlined />}
                                    >
                                        {hospitalList.map(h => (
                                            <Option key={h.id} value={h.id}>
                                                <div className="d-flex align-items-center gap-2 py-1">
                                                    <ImageShow url={h.profile_photo_url} height={24} width={24} style={{ borderRadius: '4px' }} />
                                                    <div>
                                                        <div style={{ fontWeight: 600, fontSize: '13px' }}>{sanitizeHospitalName(h.display_name)}</div>
                                                        <div style={{ fontSize: '11px', color: '#94a3b8' }}>{h.address}</div>
                                                    </div>
                                                </div>
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="selected_days" noStyle>
                                    <DayTimeSlots
                                        selectedDays={form.getFieldValue('selected_days')}
                                        onDaysChange={(days) => form.setFieldsValue({ selected_days: days })}
                                        dayTimeSlots={form.getFieldValue('day_time_slots') || {}}
                                        onTimeSlotsChange={(slots) => form.setFieldsValue({ day_time_slots: slots })}
                                    />
                                </Form.Item>

                                <div className="row">
                                    <div className="col-6">
                                        <Form.Item name="intervals" label={<Text strong>Interval (min)</Text>}>
                                            <Select size="large">
                                                {[5, 10, 15, 20, 30, 45, 60].map(v => <Option key={v} value={v}>{v} mins</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    <div className="col-6">
                                        <Form.Item
                                            name="durations"
                                            label={<Text strong>Duration (min)</Text>}
                                            rules={[{ required: true }]}
                                        >
                                            <Select size="large">
                                                {[5, 10, 15, 20, 30, 45, 60, 90, 120].map(v => <Option key={v} value={v}>{v} mins</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <Form.Item
                                            name="consultant_fee"
                                            label={<Text strong>Fee (₹)</Text>}
                                            rules={[{ required: true, message: 'Fee is required' }]}
                                        >
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                size="large"
                                                min={0}
                                                placeholder="e.g. 500"
                                                prefix={<DollarCircleOutlined style={{ color: '#94a3b8' }} />}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="col-6">
                                        <Form.Item name="spaces" label={<Text strong>Daily Slots</Text>}>
                                            <InputNumber style={{ width: '100%' }} size="large" min={1} max={100} />
                                        </Form.Item>
                                    </div>
                                </div>

                                <Divider />

                                <div className="d-grid gap-3">
                                    <Button
                                        type="primary"
                                        size="large"
                                        htmlType="submit"
                                        loading={isSubmitting}
                                        style={{ height: 56, borderRadius: '14px', fontWeight: 700, fontSize: '16px', background: '#3182ce' }}
                                    >
                                        {isEditing ? 'Save Changes' : 'Create Schedule'}
                                    </Button>
                                    {isEditing && (
                                        <Button size="large" onClick={resetForm} style={{ borderRadius: '14px', height: 48 }}>
                                            Discard Edit
                                        </Button>
                                    )}
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            {showBreakTimeModal && (
                <BreakTimeModal
                    isOpen={showBreakTimeModal}
                    onClose={() => setShowBreakTimeModal(false)}
                    appointment={selectedAppointment}
                    refresh={() => {
                        getAppointmentSettings();
                        if (onActivityLog) {
                            onActivityLog("appointment_settings_break", `scheduled break time for doctor profile (Hospital ID: ${selectedAppointment?.hospital_id})`);
                        }
                    }}
                />
            )}
        </>
    );
};

export default AppointmentSettings;
